import React from "react";
import Topheader from '../components/Topheader';

export default function TournamentRules() {
  return (
    <>
    <Topheader colorbox="newfaq_header_color" title="Mga Panuntunan sa Tournament" />
      <div className="container py-3">
          <ul style={{paddingLeft:"15px", fontWeight:"500"}}>
            <li>
              Ang mga torneo ay nagsisimula sa mga itinakdang oras, at ang mga
              upuan ay itinalaga nang random.
            </li>
            <li>
              Ang torneo ay nagtatapos kapag ang isang manlalaro ay naipon na
              ang lahat ng chips sa laro.
            </li>
            <li>
              Ang mga manlalarong nawalan ng lahat ng kanilang chips ay aalisin
              sa laro, maliban kung pinahihintulutan ang mga re-entries o
              re-buys.
            </li>
            <li>
              Kung ang dalawa o higit pang manlalaro ay naaalis sa parehong
              kamay, ang manlalarong nagsimula ng kamay na may mas maraming
              chips ay magtatapos sa mas mataas na posisyon.
            </li>
            <li>
              Ang Time Bank ay nagbibigay ng karagdagang oras ng desisyon na
              maaaring gamitin ng mga manlalaro kapag kinakailangan. Ang oras
              ay maaaring kunin mula sa bangko hanggang sa ganap na maubusan.
            </li>
            <li>
              Lahat ng karaniwang panuntunan sa poker tournament ay naaangkop
              sa Multi-Table Tournaments (MTTs).
            </li>
            <li>
              Ang mga torneo ay nagbibigay ng libreng play chips o Reward
              Points bilang mga premyo. Walang tunay na pera na ipinamamahagi
              sa anumang yugto.
            </li>
            <li>
              Ang App store ay walang kinalaman sa pag-host ng torneo o sa
              pamamahagi ng Reward Points o libreng play chips bilang mga
              premyo.
            </li>
          </ul>
        </div>
    </>
  );
}
